import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Box, Typography, Paper } from '@mui/material';

const APIUsageChart = ({ data, title = "API Usages" }) => {
  // Transform data for recharts
  const chartData = data.map(item => ({
    name: item.serviceName.replace(' Verification', '').replace('Basic ', ''),
    Calls: item.totalCalls,
    Success: item.successCount,
    Failure: item.failureCount
  }));

  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
      <Typography variant="h6" gutterBottom align="center" sx={{ mb: 3 }}>
        {title}
      </Typography>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="name" 
            angle={-45}
            textAnchor="end"
            height={100}
            interval={0}
            style={{ fontSize: '12px' }}
          />
          <YAxis />
          <Tooltip />
          <Legend 
            wrapperStyle={{ paddingTop: '20px' }}
            iconType="rect"
          />
          <Bar dataKey="Calls" fill="#FF9800" name="Total Calls" />
          <Bar dataKey="Success" fill="#2196F3" name="Success" />
          <Bar dataKey="Failure" fill="#F44336" name="Failure" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default APIUsageChart;
